<template>
  <div class="bidPlan">
    <el-container>
      <el-header>
        <el-form ref="form" :model="searchForm" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="采购计划编号" label-width="120px">
                <el-input
                  v-model="searchForm.bidPlanCode"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称" label-width="120px">
                <el-input
                  v-model="searchForm.projectName"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="提报部门" label-width="120px">
                <el-select v-model="searchForm.projectDeptId" placeholder="请选择">
                  <el-option
                    v-for="item in deptIdList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="采购计划事项" label-width="120px">
                <el-input
                  v-model="searchForm.bidPlanItem"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="项目类别" label-width="120px">
                  <el-input v-model="searchForm.projectType"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="采购方式" label-width="120px">
                  <el-select
                    v-model="searchForm.bidPlanMethodKey"
                    filterable
                    default-first-option
                    placeholder="请选择"
                    @change="changeType"
                  >
                    <el-option
                      v-for="item in typeOption"
                      :key="item.label"
                      :label="item.value"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 18 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              icon="el-icon-plus"
              @click="addBidPlan()"
              >新建</el-button
            >
            <el-button
              title="导出"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportDataList()"
              >导出</el-button
            >
            <!-- <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              icon="el-icon-edit"
              @click="editBidPlan()"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.delBtn.btnEnable"
              icon="el-icon-delete"
              @click="delBidPlan()"
              >删除</el-button
            > -->
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.column.property == 'isDecisionBase'">{{
                scope.row[scope.column.property] == "1" ? "是" : "否"
              }}</span>
              <span v-else-if="scope.column.property == 'isDiscard'">{{
                scope.row[scope.column.property] == "1"
                  ? "是"
                  : scope.row[scope.column.property] == "2"
                  ? "部分作废"
                  : ""
              }}</span>
               <div v-else-if="scope.column.property == 'projectGeneral'">
                <div>
                  {{ scope.row["projectGeneral"].length>900?`${scope.row["projectGeneral"].substring(0,800)}...`:scope.row["projectGeneral"] }}
                </div>
              </div>
              <div v-else-if="scope.column.property == 'remark'">
                <div>
                  {{ scope.row["remark"].length>900?`${scope.row["remark"].substring(0,800)}...`:scope.row["remark"] }}
                </div>
              </div>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editBidPlan(scope.row)"
                v-if="
                  btnAuthorize.modifyBtn.btnEnable &&
                  scope.row.status != 2 &&
                  scope.row.status != 3
                "
                >修改</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="delBidPlan(scope.row)"
                v-if="btnAuthorize.delBtn.btnEnable && scope.row.status != 3&& scope.row.status != 2"
                >删除</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="bidPlanDetail(scope.row)"
                >详情</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="callbackBid(scope.row)"
                v-if="btnAuthorize.callback.btnEnable && scope.row.status == 2"
                >撤回</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="abandBid(scope.row)"
                v-if="btnAuthorize.abandBid.btnEnable && scope.row.status == 3"
                >作废</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getBidPlan, //获取采购计划列表接口
  deletebidPlan, //删除一条采购计划
  abandbidPlan, //作废
  getOnePlanItems,
  getprojectGeneral,
  exportListApi, //导出接口
  getBidTypeDic, //获取一级数据字典接口
} from "@/services/bidServices";
import { exportExcelService2 } from "@/services/commonService";
import { recallApproveItemFun } from "@/page/approveComponents/approve";

export default {
  name: "bidPlanMsg",
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      typeOption: [],
      projectGeneral:'',
      searchForm: {
        //查询条件form
        bidPlanCode: "", //采购计划编号
        projectName: "", //项目名称
        bidPlanItem: "",
        projectType: "", //项目类别
        bidPlanMethodKey: "",
      },
      tableColumns: [
        { class: "bidPlanCode", labelName: "采购计划编号", sortEnable: false },
        { class: "projectName", labelName: "项目名称", sortEnable: false },
        { class: "bidPlanItem", labelName: "采购计划事项", sortEnable: false },
        {
          class: "projectGeneral",
          labelName: "项目主要内容",
          sortEnable: false,
        },
        { class: "projectType", labelName: "项目类别", sortEnable: false },
        // { class: "applyUserName", labelName: "提报部门", sortEnable: false },
        {
          class: "estimatePrice",
          labelName: "预估金额(万元)",
          sortEnable: false,
        },
        {
          class: "bidPlanMethodValue",
          labelName: "采购方式",
          sortEnable: false,
        },
        {
          class: "isDecisionBase",
          labelName: "是否已取得决策依据",
          sortEnable: false,
        },
        { class: "remark", labelName: "备注", sortEnable: false },
        {
          class: "statusDisplayName",
          labelName: "审核状态",
          sortEnable: false,
        },
        { class: "isDiscard", labelName: "是否作废", sortEnable: false },
      ],
      showAdvanceFilter: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        import: { key: "import", btnEnable: false }, //导入
        callback: { key: "callback", btnEnable: false }, //撤回
        abandBid: { key: "abandBid", btnEnable: false }, //作废
        export: { key: "export", btnEnable: false },
      },
      gridData: [],
    };
  },
  mounted() {
    this.getbidPlanType();
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    onActive(menuCode) {
      // this.searchForm.id = this.tabRouteParam?.id ?? "";
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
    },
    //点击查询
    handleClick() {
      this.currentPage = 1;
      this.initList();
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭审批弹窗吗?", "提示", {
        confirmButtonText: "确认",
      })
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取采购计划列表
    initList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      for (let key in this.searchForm) {
        if (this.searchForm[key] !== "") {
          param[key] = this.searchForm[key];
        }
      }
      getBidPlan(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    getGeneral(row){
      let param = {
        bidPlanId: row.id,
      };
      getprojectGeneral(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            row.projectGeneral = res.data.projectGeneral;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //获取采购计划列表
    getOnePlanItem(row) {
      let param = {
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        bidPlanId: row.id,
      };
      getOnePlanItems(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.gridData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
      for(let i=0;i<this.tableData.length;i++){
        this.getGeneral(this.tableData[i])
      }
     }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //双击跳转采购计划详情
    bidPlanDetail(row, column, cell, event) {
      let param = {};
      param.id = row.id;
      param.routeId = "bidPlanDetail";
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanDetail",
        routeParam: param,
      });
    },

    //跳转到创建界面
    addBidPlan() {
      let memberData = {};
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanAdd",
        routeParam: memberData,
      });
    },
    //跳转到修改界面
    editBidPlan(row) {
      // if (
      //   row.status == 1 &&
      //   row.status == 4 &&
      //   row.status == 0
      // ) {
      //   this.$alert("只有 撤回/驳回/已保存 状态的合同可以修改", "提示", {
      //     confirmButtonText: "确定",
      //   });
      //   return;
      // }
      let memberData = {};
      memberData.id = row.id; //选中行
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanEdit",
        routeParam: memberData,
      });
    },
    //撤回
    callbackBid(row) {
      let param = {
        itemId: row.id,
        type: "BID_PLAN",
      };
      this.$confirm("确认撤回该条采购计划数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(async () => {
        let res = await recallApproveItemFun(param);
        if (res && res.code == 10000000) {
          this.$message.success("撤回成功");
          this.handleClick();
        }
      });
    },
    //删除
    delBidPlan(row) {
      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.bidPlanId = row.id;
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deletebidPlan(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    //作废
    abandBid(row) {
      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.bidPlanId = row.id;
      this.$confirm("确认要执行作废操作?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        abandbidPlan(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("作废成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    //导出
    exportDataList() {
      exportListApi(this.searchForm)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.bidPlan {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
